import type { DesignSpec, StylePreferences } from '../types/design-spec';
import type { ProjectConfig } from '../types/project';

export interface AnalyzeReferencesInput {
  urls: string[];
  industry?: string;
  archetype?: string;
  brandInfo?: {
    name?: string;
    tagline?: string;
    description?: string;
  };
  stylePreferences?: StylePreferences;
}

export interface AnalyzeReferencesSuccess {
  success: true;
  designSpec: DesignSpec;
  projectConfig?: Partial<ProjectConfig>;
  rawAnalysis: string;
}

export interface AnalyzeReferencesError {
  success: false;
  error: string;
}

export type AnalyzeReferencesResponse = AnalyzeReferencesSuccess | AnalyzeReferencesError;

const DEFAULT_WORKER_URL = 'https://promptforge-worker.jimsbond007.workers.dev';

export function getWorkerUrl(): string {
  const envUrl = import.meta.env.VITE_PROMPTFORGE_WORKER_URL as string | undefined;
  return (envUrl || DEFAULT_WORKER_URL).replace(/\/$/, '');
}

export async function analyzeReferences(input: AnalyzeReferencesInput): Promise<AnalyzeReferencesResponse> {
  const workerUrl = getWorkerUrl();

  try {
    const response = await fetch(`${workerUrl}/api/analyze-references`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });

    const data = (await response.json()) as AnalyzeReferencesResponse;

    if (!response.ok) {
      if ('error' in data && typeof data.error === 'string') {
        return { success: false, error: data.error };
      }
      return { success: false, error: `Worker returned ${response.status}` };
    }

    return data;
  } catch (err) {
    return {
      success: false,
      error: err instanceof Error ? err.message : '無法連線到分析服務，請檢查網絡連線。',
    };
  }
}
